import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { XCircle, ArrowLeft } from "lucide-react";

export default function PaymentCancelPage() {
  return (
    <div className="min-h-screen flex items-center justify-center px-6" data-testid="payment-cancel-page">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        className="max-w-lg text-center"
      >
        <XCircle size={52} className="mx-auto text-[#C9501C]" />
        <h1 className="mt-8 font-serif-display text-4xl sm:text-5xl tracking-tight text-[#2A2118]">
          Checkout cancelled
        </h1>
        <p className="mt-6 text-base leading-relaxed text-[#7A6C5A]">
          No charge was made. Your cart is still waiting whenever you're ready.
        </p>
        <Link
          to="/shop"
          data-testid="payment-cancel-back-link"
          className="mt-10 group inline-flex items-center gap-3 border border-[rgba(42,33,24,0.22)] hover:border-[#2A2118] text-[#2A2118] font-mono-accent text-xs uppercase tracking-[0.3em] px-8 py-4 transition-colors duration-300"
        >
          <ArrowLeft size={15} />
          Return to collection
        </Link>
      </motion.div>
    </div>
  );
}
